{
  "retry": "Retry",
  "notFound": "Training Module not found.",
  "backToTraining": "Back to Training",
  "edit": "Edit",
  "lessonsHeading": "Lessons",
  "newLesson": "New Lesson",
  "emptyTitle": "No Lessons",
  "emptyMessage": "Add a Lesson to this Module to get started.",
  "videoProcessing": "Processing",
  "videoFailed": "Video failed",
  "video": "Video"
}
